// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { signInPageLayoutStyles } from "@steiner/App/Widgets/Layout/SignInPageLayout";
import { Divider, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

signInPageLayoutStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        width: 100%;
        ${({ showAsColumns }: any) =>
            showAsColumns &&
            css`
                padding: 48px 20px 148px 20px;
                flex-direction: row;
                justify-content: center;
                ${xScreen("lte", "md")} {
                    flex-direction: column;
                    padding: 25px 0 100px 0;
                    ${Divider} {
                        width: 100%;
                        height: 1px;
                        margin: 32px 0;
                    }
                }
            `}
    `,
};

signInPageLayoutStyles.signInSection = {
    css: css`
        flex: 1;
        max-width: 390px;
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};

signInPageLayoutStyles.supportServicesSection = {
    css: css`
        flex: 1;
        max-width: 390px;
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};

signInPageLayoutStyles.createAccountSection = {
    css: css`
        flex: 1;
        max-width: 390px;
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};

signInPageLayoutStyles.guestCheckoutSection = {
    css: css`
        flex: 1;
        max-width: 390px;
        ${xScreen("lte", "md")} {
            flex: 0 0 100%;
            max-width: 100%;
        }
    `,
};

signInPageLayoutStyles.returnToQuoteMessage = {
    css: css`
        display: inline-block;
    `,
};